{
  "_provenance": {
    "ns": "companion",
    "source": "the companion surfaces shared by the parent and trfer homes: components/companion/** (#2109 R3 lane L1)"
  },
  "archive": {
    "filterLabel": "Filter conversations",
    "label": "Conversations",
    "newConversation": "New conversation",
    "scope": {
      "all": "All",
      "text": "Text",
      "voice": "Voice"
    },
    "show": "Show",
    "showMore": "Show more"
  },
  "callout": {
    "noticed": "{{companion}} · noticed something",
    "takeMeThere": "Take me there",
    "thinkItThrough": "Think it through with me"
  },
  "history": {
    "empty": "No conversations yet. {{companion}} is here whenever you want to start one.",
    "loadError": "We couldn’t load your conversations.",
    "loading": "Loading conversations",
    "noMatch": "No conversations match.",
    "retry": "Retry",
    "search": "Search your conversations",
    "title": "Conversation history"
  },
  "ideas": {
    "heading": "Ideas for you"
  },
  "pager": {
    "moreNotes": "More notes"
  }
}
